//let serverUrl = 'http://test.jinmdz.com.cn:60/efz/'
//现场环境
let serverUrl = 'https://xcxgwjk.ccjly.com:443'
let sacrificeUrl = 'https://jk.ccjly.com/yjsqd'
let parkUrl = 'https://jk.ccjly.com/gwjng'
//测试环境
// let serverUrl = 'http://ccjk.jinmdz.com.cn:90/'
// let sacrificeUrl = 'http://ccjk.jinmdz.com.cn:90/yjsqd'
// let parkUrl = 'http://ccjk.jinmdz.com.cn:90/gwjng'
//本地环境
// let serverUrl = 'http://192.168.1.66:9009/'
// let sacrificeUrl = 'http://192.168.1.66:9521/app/1/2/3'
// let parkUrl = 'http://192.168.1.66:9521/app'
let staticUrl = 'sys/common/static/'

export {
  serverUrl,
  sacrificeUrl,
  parkUrl,
  staticUrl,
}



//////////////////
// WEBPACK FOOTER
// ./static/js/config.js
// module id = null
// module chunks = 